import { call, put } from "redux-saga/effects";
import { Auth } from "aws-amplify";

import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzUserLogout(): Generator<any, any, any> {
  return yield Auth.signOut();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzUserLogoutWorker(action: any): Generator<any, any, any> {
  const { navigate } = action;

  try {
    yield call(authnzUserLogout);
    navigate("/login");

    // clears the session
    sessionStorage.clear();
  } catch (error) {
    if (error instanceof Error) {
      yield put(
        MiniMessageBox.showMiniBoxMessage({
          show: true,
          type: "error",
          message: error.message,
        }),
      );
    }
  }
}
